import { LitElement, html } from 'lit';
import { getDefaultEnv } from '../shared/utils/helpers';
import styles from '../shared/styles';
import '../shared/context/app-context/AppContextProvider';
import '../shared/components/localize/Localize';
import './components/build-channel-table/BuildChannelTable';
import BuildChannelApi from '../shared/api/BuildChannelApi';

class BuildChannel extends LitElement {
  static styles = styles;

  static properties = {
    env: {
      type: String,
      reflect: true,
    },
    builds: {
      type: Object,
      state: true,
    },
    type: {
      type: String,
    },
  };

  constructor() {
    super();
    this.env = '';
    this.builds = {};
    this.type = 'nessus';
  }

  async firstUpdated() {
    try {
      const { data } = await this.BuildChannelApi.all();

      if (this.type === 'nessus') {
        this.builds = data?.nessus_build_channels ?? {};
      }

      if (this.type === 'agent') {
        this.builds = data?.agent_build_channels ?? {};
      }
    } catch (error) {
      console.error('Build channel request error', error);
    }
  }

  connectedCallback() {
    super.connectedCallback();

    const { env } = getDefaultEnv(this.env, {
      production: ['docs.tenable.com'],
      staging: [
        'docs-staging.tenable.com',
        'docs-jp-staging.tenable.com',
        'docs-kr-staging.tenable.com',
        'docs-de-staging.tenable.com',
        'docs-fr-staging.tenable.com',
        'docs-zh-cn-staging.tenable.com',
        'docs-zh-tw-staging.tenable.com',
      ],
    });

    this.BuildChannelApi = new BuildChannelApi({ env });
    this.env = env;
  }

  render() {
    return html`
      <tenable-app-provider .value=${{ env: this.env }}>
        <tenable-localize>
          <tenable-build-channel-table .builds=${this.builds}></tenable-build-channel-table>
        </tenable-localize>
      </tenable-app-provider>
    `;
  }
}

customElements.define('tenable-build-channel', BuildChannel);
